<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list" class="relative">
    <div class="page_header_wrap" :class="{ filters_open: filtersList }">
      <div class="page_header">
          <div>
            <h2 ><a><img src="@/assets/images/pages/arrow.png"></a>Projects</h2>
          </div>
          
          <div class="page_actions">
            <div class="page_search">
                  <div class="company_dropdown">
                  
                  
                    <multiselect
                    v-model="selectedCompany"
                    :options="companies"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :hide-selected="false"
                    :preserve-search="true"
                    placeholder="Select Company"
                    label="name"
                    track-by="name"
                    :preselect-first="false"
                    id="status"
                    :multiple="false"
                    @input="getCompanyProjects"
                    
                  
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Company(s) selected</span
                      >
                      <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                      ></span>
                    </template>
                    <span slot="noResult">No Companies Found</span>
                  </multiselect>
                  </div>
            </div>
            <div class="page_search" v-if="companyId">
              <input
                v-model="serch_title"
                  class="search_field"
                  type="text"
                  @keyup="onEnter"
                  placeholder="Search By Name"
                  
                />
            </div>
            
         
          </div>
        </div> 
        <div class="filter_layer" @click="filtersList = !filtersList"></div>
        <div
      ref="filterCard" 
      class="user-list-filters filters_list"
      actionButtons
      @refresh="resetColFilters"
      @remove="resetColFilters"
    >
      <div class="vx-row">
        <div class="vx-col md:w-2/4 sm:w-1/2 w-full marb10">
         <label class="text-sm opacity-75">Search</label>
          <input
           v-model="serch_title"
            class="search_field"
            type="text"
            @keyup.enter="onEnter"
            placeholder="Search By Name"
          />
        </div>
        
        <div class="vx-col md:w-2/4 sm:w-1/2 w-full d-flex align-end justify-end marb10" >
          <button @click="clearFilters()" class="secondary_btn">
              Clear
            </button>
          <button class="primary_btn marl15" @click="getList() , filtersList = !filtersList" >
            Apply 
          </button>
        </div>
        
      </div>
    </div>
    </div>



    <div class="invite_btn">
  
    </div>
    

    

    <div class="vx-card">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow d-flex justify-content-between"></div>
       
      </div>

      <vs-table :data="users" noDataText="">
        <template slot="thead">
          <vs-th>
            
            <span>
              Name
            </span>
          </vs-th>
          <vs-th>
            
             
              <span>
              Owners
            </span>
          </vs-th>
           <vs-th>
            
             <span>
              Shared To
            </span>
          </vs-th>
         
          <vs-th>
            <span>
              Created By
            </span>
          </vs-th>
          <vs-th>
            <span>
              Actions
            </span>
          </vs-th>
         
        </template>

        <template v-if="rolesList && rolesList.length > 0">
          <vs-tr v-for="(item, index) in rolesList" :key="index">
            <vs-td>
            
              {{ item.name}}
             
            </vs-td>
            <vs-td>
              <ul class="td_addigned_list"> 
            <template v-if="checkProperty(item ,'ownersDetails')">
                <template v-for="(item1, ind) in item.ownersDetails">
                <li :key="ind" v-if="ind < 1" >
                  <div class="td_addigned_name">
                    <span>{{ item1.name|truncate(2) }}</span>
                    <label>{{ item1.name }}</label>
                  </div>

                  <!-- <vs-dropdown >
                    <a class="a-icon" href.prevent><span >{{ item1.shortName }}</span></a>
                    <vs-dropdown-menu>
                      <vs-dropdown-item>{{ item1.name }}</vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown> -->
                </li>
             
                </template>
              </template>  
              <li v-if=" checkProperty(item ,'ownersDetails') &&  item.ownersDetails.length > 1">
                
                
                <vs-dropdown vs-trigger-click>
                   <template v-if="item.ownersDetails.length > 1">
                      <a class="a-icon more" href.prevent> 
                  <span>{{ item.ownersDetails.length - 1 }}+</span>
                </a>               
                 </template>   

                <vs-dropdown-menu>
                  <vs-dropdown-item  v-if="item.ownersDetails.length > 1">
                     <template v-for="(item1, ind) in item.ownersDetails">
                          <span class="list_item padtb5" v-if="ind >= 1" :key="ind">{{ item1.name }}</span>
                                                      
                            </template>
                 
                    </vs-dropdown-item>

                     
                </vs-dropdown-menu>
              </vs-dropdown>


                
              </li>
            </ul>
            </vs-td>

            <vs-td>
              <ul class="td_addigned_list"> 
            <template v-if="checkProperty(item ,'ownersDetails')">
                <template v-for="(item1, ind) in item.sharedToDetails">
                <li :key="ind" v-if="ind < 1" >
                  <div class="td_addigned_name">
                    <span>{{ item1.name|truncate(2) }}</span>
                    <label>{{ item1.name }}</label>
                  </div>

                  <!-- <vs-dropdown >
                    <a class="a-icon" href.prevent><span >{{ item1.shortName }}</span></a>
                    <vs-dropdown-menu>
                      <vs-dropdown-item>{{ item1.name }}</vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown> -->
                </li>
             
                </template>
              </template>  
              <li v-if=" checkProperty(item ,'sharedToDetails') &&  item.sharedToDetails.length > 1">
                
                
                <vs-dropdown vs-trigger-click>
                   <template v-if="item.sharedToDetails.length > 1">
                      <a class="a-icon more" href.prevent> 
                  <span>{{ item.sharedToDetails.length - 1 }}+</span>
                </a>               
                 </template>   

                <vs-dropdown-menu>
                  <vs-dropdown-item  v-if="item.sharedToDetails.length > 1">
                     <template v-for="(item1, ind) in item.sharedToDetails">
                          <span class="list_item padtb5" v-if="ind >= 1" :key="ind">{{ item1.name }}</span>
                                                      
                            </template>
                 
                    </vs-dropdown-item>

                     
                </vs-dropdown-menu>
              </vs-dropdown>


                
              </li>
            </ul>
            </vs-td>
            <vs-td>
           
              <ul class="td_addigned_list"> 
              <li  v-if="checkProperty(item , 'createdByDetails' ,'name')">
                  <div class="td_addigned_name">
                    <span>{{ item.createdByDetails.name|truncate(2) }}</span>
                    <label>{{ item.createdByDetails.name }}</label>
                  </div>
              </li>
              </ul>
            </vs-td>
             <vs-td> 
           <vs-dropdown vs-trigger-click>
              <a class="a-icon" href.prevent> 
                <span class="material-icons">more_vert</span>
              </a>

              <vs-dropdown-menu>
                  <vs-dropdown-item v-if="activeUserInfo && activeUserInfo.roleId == 1">
                    <a  @click="openAssignPopup(item)"><span>Share To</span></a>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
             
             </vs-td>
            
          </vs-tr>
        </template>
        <template v-else>
          <template v-if="!companyId && activeUserInfo.roleId == 1">
            <tr v-if="!loading" >
            <td colspan="5" class="center-align">Company not selected</td>
          </tr>
          </template>

          <template v-else>
            <tr v-if="!loading" >
            <td colspan="5" class="center-align">No Projects Found!</td>
          </tr>
          </template>
          
        </template>
      </vs-table>
      

    </div>
    
    <div class="pagination_wrap" v-if="totalpages > 0">
      <div class="pagination_content">
        <h6>Show Records</h6>
         <multiselect
          :multiple="false" 
            @input="change_perPage()"
          placeholder="Page"
          
          :close-on-select="true"
          :clear-on-select="false"
          :hide-selected="true"
          :preserve-search="true"
          v-model="perPage" :options="perPeges" >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            
          </multiselect>
      </div>
      <vs-pagination
        :total="totalpages"
        :max="7"
        v-model="page"
        @input="callFromSort =true;getList()"
      />
    </div>
  
   <vs-popup
        class="holamundo"
        :active.sync="popupAssignFlag"
        title="Manage project assignments"
      >
        <div class="createticket_form">
          <form autocomplete="off">
          <ul>
            <li>
              <div class="form-group">
                            
                <label class="form_label">Share  To Internal Employee</label>
                <multiselect
                  v-model="shareTodeepEmp" 
                  :options="deepVissionEmployeeList"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false" 
                  :preserve-search="true"
                  placeholder="Select Internal Employee"
                  label="name"
                  track-by="name"
                  :preselect-first="false"
                  id="assign"
                  :multiple="true"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                    
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Employee(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Employees Found</span>
                </multiselect>
              </div>
            </li>
         <li>
              <div class="form-group">
                           
                <label class="form_label">Share To Customer Employee</label>
                <multiselect
                  v-model="shareTocusEmp" 
                  :options="customerEmployeeList"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false" 
                  :preserve-search="true"
                  placeholder="Select Customer Employee"
                  label="name"
                  track-by="name"
                  :preselect-first="false"
                  id="assign"
                  :multiple="true"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                    
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} Employee(s) selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                  <span slot="noResult">No Employees Found</span>
                </multiselect>
              </div>
            </li>
          </ul>
        </form>
          <div class="form_actions">
            <span></span>
            <!----:disabled="!validateAssign"--->
            <button class="close_popup primary_btn" 
            :disabled="shareTodeepEmp.length<=0 && shareTocusEmp.length<=0 "
              
              @click="onAssignEmployee()">
              Update
            
            </button>
          </div>
        </div>
   </vs-popup>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import tableheader from "@/views/pages/UsersListHeaders.vue";
import noData from "@/views/components/noData.vue";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

// Store Module
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import Multiselect from "vue-multiselect-inv";

export default {
  components: {
    AgGridVue,
    vSelect,
    tableheader,
    DateRangePicker,
    VuePhoneNumberInput,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    Multiselect,
  },
  data() {
    return {
      projectId:'',

      selectedProjectDetails:null,
      popupAssignFlag:false,
      shareTodeepEmp:[],
      shareTocusEmp:[],
      customerEmployeeList:[],
      deepVissionEmployeeList:[],
      companyId:"",
      companies:[],
      selectedCompany:null,
      loading:false,
        callFromSort:false,
        slectedClient:null,
        slectedClientDefaultValue:5,
      filtersList: false,
      popupTitle:"Inactivity Threshold",
      popupcreateticket: false,
      popupApprove: false,
      switch1: true,
      switch2: true,
      switch3: true,
      rolesList: [],
      sortKey: {},
      email: "",
      users: "",
      page: 1,
      perPage: 25,
      totalpages: 0,
      selected_statuss: [],
      status_list: [],
      cusId: "",
      updateUser: false,
      activeUserFlag: false,
       selected_createdDateRange:{},
      autoApply: "",
      inActiveUserFlag: false,
      userId: "",

      sortKeys: {
        name: 1,
        name:1,
        statusName: 1,
        createdOn: -1,
        email: 1,
        roleName: 1,
      },

      startDate: new Date(),
      endDate: new Date(),
      serch_title: "",

      userRoles: [],
      createUserRoles: [],
      selected_userRoles: [],
      settings_list: [],
      /*   settings_list: [
         { name: 'SDK Download', _id: 'sdkDownload' },
        { name: 'SDK Docs', _id: 'sdkDocs' },
        { name: 'Support Tickets', _id: 'supportTicket' },
      ],
      settings: {
        sdkDownload : false,
        sdkDocs : false,
        supportTicket : false
      },*/
      selected_settings: [],
      searchQuery: "",

      userCreate: {},
      // AgGrid
      gridApi: null,
      gridOptions: {},
      perPeges: [25, 50, 75, 100],
      filterData: {
        statusIds: [],
        roleIds: [],
        createdOnRange: [],
      },

      userFilters: {
        statusIds: [],
        roleIds: [],
        createdOnRange: [],
      },

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    },
  },
  computed: {
    activeUserInfo () {
      console.log(JSON.stringify(this.$store.state.auth.user));
      return this.$store.state.auth.user
    },
    usersData() {
      return this.$store.state.userManagement.users;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.userCreate.name !== ""
      );
    },
  },
  methods: {
    
    getDeepvissionEmployees(){
       this.$store.dispatch("getEmployeeList").then((response) => {
         
      this.deepVissionEmployeeList = response;
      this.deepVissionEmployeeList.forEach(item => {
        item.name = item.name + '('+item.roleName +')'
      })

      
      
    });
    },
    getCustomerEmployeeList(){

      let postData = {
        "filters":{
          "title":"",
          "roleIds":[],
          "statusIds":[2], //get only active Users
          "companyIds":[this.companyId],
          "createdOnRange":[]
          },
          "sorting":{"path":"createdOn","order":-1},
          "page":1,
          "perpage":25000000,
          getMasterData:true
          };
       this.$store.dispatch("auth/get_users_list" ,postData).then((response) => {
     
      let customerEmployeeList = response.list;
      this.customerEmployeeList =[];
      customerEmployeeList.forEach(item => {
        
        let user = { "_id": item['_id'], "name": item.name, "photo": "", "gender": "", "roleName": "", "roleId": ''}
         user['roleId'] = item['roleId'];
        if(_.has(item ,"roleDetails")){
          user.name = user.name + '('+item['roleDetails']['name'] +')'
          user['roleName'] = item['roleDetails']['name'];
          
        }
        this.customerEmployeeList.push(user);
        
      })
      
    });
    },
    onAssignEmployee(){
      
      //alert(JSON.stringify(this.selectedProjectDetails['owners']));

      if(this.shareTodeepEmp.length>0 || this.shareTocusEmp.length>0){
        let postData ={
          name:this.selectedProjectDetails['name'],
          mDataId:this.projectId,
          category : 'project',
          companyId:this.companyId,
          sharedTo:[],
          owners:this.selectedProjectDetails['owners'],
        };
        _.forEach(this.shareTodeepEmp , (item)=>{
           if(postData.sharedTo.indexOf(item['_id']) <=-1){
             postData.sharedTo.push(item['_id']);
           } 
        });
        _.forEach(this.shareTocusEmp , (item)=>{
           if(postData.sharedTo.indexOf(item['_id']) <=-1){
             postData.sharedTo.push(item['_id']);
           } 
        });
        
        this.$store.dispatch("projectUpdate",{details:postData})
        .then((res)=>{
          this.popupAssignFlag =false;
          this.$store.dispatch("clearCatche",postData);
          this.getList();
          this.$vs.notify({
              title: "Success",
              text: res.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              position: "top-right",
              color: "success",
            });
        })
        .catch((err)=>{
           this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: err.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
        });
        

      }
    },
    openAssignPopup(item) {
// shareTodeepEmp:[],
// shareTocusEmp:[],
// customerEmployeeList:[],
// deepVissionEmployeeList:[],
      this.selectedProjectDetails =item;
      this.projectId = item._id;
      this.shareTodeepEmp =[];
      this.shareTocusEmp =[];
        if (item.sharedToDetails && item.sharedToDetails.length > 0) {
           

          item.sharedToDetails.forEach(obj => {
               if(obj ,"roleName"){
                   obj.name = obj.name + '('+obj.roleName +')'
               }

             if(_.findIndex(this.customerEmployeeList ,{"_id":obj['_id']}) >-1){
                this.shareTocusEmp.push(obj);
             }
             if(_.findIndex(this.deepVissionEmployeeList ,{"_id":obj['_id']}) >-1){
               this.shareTodeepEmp.push(obj);
             }

             
            })

           
        } 
      this.popupAssignFlag = true;
    },
    getCompanyProjects(item){
      this.selectedCompany =item;
      if(_.has(this.selectedCompany , "_id")){
        this.companyId = this.selectedCompany["_id"];
        this.getList();
        
      }

    },
      checkProperty(obj ,key='' ,subKye=''){
      
      if(_.has(obj , key)){
         //alert(key+" ---"+subKye)
        if(obj[key]){
          if(subKye==''){
            return obj[key];
          }else{

            if(_.has(obj[key] , subKye)){
              if(obj[key][subKye]){
                 return obj[key][subKye];
              }else{
                 return false;
              }

            }else{
              return false;
            }
          }
          
        }else{
          return false;
        }
     

      }else{
        return false;
      }

    }, 
     
    
       
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    getList() {
        
       if(this.companyId){ 
        
         this.getCustomerEmployeeList();
       let postData = {"matcher":{
           "companyIds":[this.companyId],
           "searchString":this.serch_title,
           "sharedToIds":[]
           },
       "page":this.page,
       "perpage":this.perPage,
       "category":"project",
       sorting: this.sortKey,
       }
       if(this.checkProperty(this.activeUserInfo ,"companyId")){
            postData['matcher']['companyId'] = this.activeUserInfo["companyId"];

        }
      if(!this.callFromSort){
          this.callFromSort =false;
          this.rolesList = [];
      }
     
      this.loading =true;
      this.$vs.loading()
        this.$store.dispatch("getMasterData", postData).then((response) => {
        this.rolesList = response.list;
        this.totalpages = Math.ceil(response.totalCount / this.perPage);
        this.loading =false;
            this.$vs.loading.close();
    })
     .catch((err) => {
          console.log(err);
          this.loaded = true;
          this.loading =false;
            this.$vs.loading.close();
        });

    }
     
    },
    apply_filter(data) {
      this.filterData = data;
      this.page = 1;
      this.userFilters = {
        title: this.serch_title,
        roleIds: [],
        statusIds: [],
        createdOnRange: [],
      };
      if (this.filterData["roleIds"].length > 0) {
        for (let i = 0; i < this.filterData["roleIds"].length; i++) {
          this.userFilters["roleIds"].push(
            this.filterData["roleIds"][i]["_id"]
          );
        }
      }
      this.settings = {
        sdkDownload: false,
        sdkDocs: false,
        supportTicket: false,
      };

      if (data["statusIds"].length > 0) {
        this.userFilters["statusIds"] = [];
        if (this.filterData["statusIds"].length > 0) {
          for (let i = 0; i < this.filterData["statusIds"].length; i++) {
            this.userFilters["statusIds"].push(
              this.filterData["statusIds"][i]["_id"]
            );
          }
        }
      }
      this.page = 1;
      this.getList();
    },
    clearFilters() {
      this.serch_title = "";
      this.selected_createdDateRange = {}
      this.filtersList =false;
      // this.filterDateRange = [];
      // this.filterData = {
      //   title: this.serch_title,
      //   roleIds: [],
      //   statusIds: [],
      //   createdOnRange: [],
      // };

      // this.userFilters = {
      //   title: this.serch_title,
      //   roleIds: [],
      //   statusIds: [],
      //   createdOnRange: [],
      // };
      this.page = 1;
      this.getList();
    },
    sortMe(sort_key = "") {
      this.sortKey = { path: "createdOn", order: 1 };
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.sortKey = {};

        this.sortKey["path"] = sort_key;
        this.sortKey["order"] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.callFromSort =true;
        this.apply_filter(this.filterData);
      }
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onEnter() {
      this.getList();
    },
    change_perPage() {
      this.callFromSort =true;
      this.page = 1;

      this.getList();
    },
   
  },
  mounted() {
    this.getDeepvissionEmployees();
    this.getCustomerEmployeeList();

    this.$store.dispatch("getCompanies").then((response) => {
          this.companies = response;
        });
    this.gridApi = this.gridOptions.api;
    this.sortKey = { path: "createdOn", order: 1 };
    this.sortKeys = {
      title: 1,
      domain: 1,
      createdOn: -1,
      name:1,
      
    };

    this.selected_settings = [];
     this.activeUserFlag = false
      this.inActiveUserFlag = false
      this.updateUser = false;

    this.getList();

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    this.$store.dispatch("getRoles").then((response) => {
      this.userRoles = response;
      this.createUserRoles = this.userRoles.map((item) => item.name);
    });
    //getuser_status
    this.$store.dispatch("getuser_status").then((response) => {
      this.status_list = response;
    });
    //get settings
    this.$store.dispatch("getSettings").then((response) => {
      this.settings_list = response;
    });
  },
  created() {
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule("userManagement", moduleUserManagement);
      moduleUserManagement.isRegistered = true;
    }
    this.$store.dispatch("userManagement/fetchUsers").catch((err) => {
      console.error(err);
    });
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.ag-header {
  height: 55px !important;
  min-height: 55px !important;
}
.ag-header-container .ag-header-row:nth-last-child(1) {
  display: none;
}
.not-data-table {
  display: none;
}
</style>
